var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreakDayCompletedFlame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_33251)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51118 15.5723C5.90036 15.3253 4.52789 13.9467 5.19268 11.0207C5.86602 11.997 6.11087 11.4812 6.11087 11.4812C6.15168 8.1653 8.66143 7.33631 8.66143 7.33631C7.91043 9.03136 9.39655 9.07821 9.498 11.0022C10.1102 10.6891 10.3346 10.3391 10.3346 10.3391C12.3614 13.0643 10.8587 15.0143 8.94138 15.5146C12.0123 15.1207 14.6526 12.5203 13.3881 6.95434C12.1171 8.79725 11.6549 7.82367 11.6549 7.82367C11.5779 1.56476 6.84064 0 6.84064 0C8.25823 3.19954 5.45305 3.28791 5.26151 6.9196C4.10609 6.32846 3.68245 5.6678 3.68245 5.6678C-0.558781 11.3707 3.38749 15.2755 7.51118 15.5723Z",
    fill: "#F9687A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_33251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5723,
    height: 15.5723,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakDayCompletedFlame);
export default __webpack_public_path__ + "static/media/streak-day-completed-flame.500b09636e7ccb4970ea2d3133a7fe72.svg";
export { ForwardRef as ReactComponent };